import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SogPage from "@/shared/ui/SogPage.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'ImpressumView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogPage, {
    title: "Impressum",
    "flex-direction": "flex-column"
  }, {
    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
      _createElementVNode("div", null, [
        _createElementVNode("p", { class: "" }, [
          _createElementVNode("strong", null, "1. Angaben gemäß § 5 des deutschen Telemediengesetzes")
        ]),
        _createElementVNode("p", { class: "" }),
        _createElementVNode("p", { class: "" }, [
          _createTextVNode(" Agent 22 GmbH "),
          _createElementVNode("br"),
          _createTextVNode("Kaiser-Wilhelm-Str. 93 "),
          _createElementVNode("br"),
          _createTextVNode("20355 Hamburg, Deutschland ")
        ]),
        _createElementVNode("p", { class: "" }, " Geschäftsführer: Martins Grants, Ambroise Fargere "),
        _createElementVNode("p", { class: "" }, [
          _createElementVNode("a", {
            class: "c-link",
            href: "https://www.handelsregister.de/rp_web/welcome.xhtml",
            target: "_blank",
            rel: "noopener noreferrer"
          }, "Handelsregister"),
          _createTextVNode(": Amtsgericht Hamburg HRB 151446 "),
          _createElementVNode("br"),
          _createElementVNode("a", {
            class: "c-link",
            href: "https://agent22.eu/error",
            target: "_blank"
          }, "Versicherungsvermittlerregister"),
          _createTextVNode(": D-TQJ0-V43WS-53 ")
        ]),
        _createElementVNode("p", { class: "" }, " USt-IdNr. DE354721093 "),
        _createElementVNode("p", { class: "" }, [
          _createTextVNode(" Mitglied der "),
          _createElementVNode("a", {
            class: "c-link",
            href: "http://www.hk24.de/",
            target: "_blank",
            rel: "noopener noreferrer"
          }, "Handelskammer Hamburg"),
          _createTextVNode(", Adolphsplatz 1, 20457 Hamburg, Deutschland ")
        ]),
        _createElementVNode("p", { class: "" }, [
          _createTextVNode(" Erlaubnis nach § 34d Abs. 1 der Gewerbeordnung (GewO) Aufsichtsbehörde: "),
          _createElementVNode("a", {
            class: "c-link",
            href: "http://www.hk24.de/",
            target: "_blank",
            rel: "noopener noreferrer"
          }, "Handelskammer Hamburg"),
          _createTextVNode(", Adolphsplatz 1, 20457 Hamburg, Deutschland "),
          _createElementVNode("br")
        ]),
        _createElementVNode("p", { class: "" }, " Berufsbezeichnung in Bezug auf die erlaubnispflichtige Tätigkeit: Versicherungsvertreter; Bundesrepublik Deutschland "),
        _createElementVNode("p", { class: "" }, " Berufsrechtliche Regelungen: § 34d Gewerbeordnung (GewO), §§ 59-68 Versicherungsvertragsgesetz (VVG) und Versicherungsvermittlerverordnung (VersVermV). "),
        _createElementVNode("p", { class: "" }, [
          _createTextVNode(" Die berufsrechtlichen Regelungen können über die vom Bundesministerium der Justiz in Kooperation mit der juris GmbH betriebene Homepage "),
          _createElementVNode("a", {
            class: "c-link",
            href: "http://www.gesetze-im-internet.de/",
            target: "_blank",
            rel: "noopener noreferrer"
          }, "gesetze-iminternet.de"),
          _createTextVNode(" eingesehen und abgerufen werden. ")
        ]),
        _createElementVNode("p", { class: "" }, " Verantwortlich für den Inhalt: Stefanie Koch "),
        _createElementVNode("p", { class: "" }),
        _createElementVNode("p", { class: "" }, [
          _createElementVNode("strong", null, "2. Haftung für Inhalte")
        ]),
        _createElementVNode("p", { class: "" }, " Obwohl wir alle Informationen und Bestandteile dieser Webseite nach bestem Wissen und Gewissen zusammengestellt haben, haften wir nicht für die Vollständigkeit, Richtigkeit, Aktualität und technische Exaktheit der auf dieser Webseite bereitgestellten Informationen. Ebenso wenig haften wir für etwaige Schäden, die beim Aufrufen oder Herunterladen von Daten aus dieser Webseite durch Computerviren verursacht werden. "),
        _createElementVNode("p", { class: "" }),
        _createElementVNode("p", { class: "" }, [
          _createElementVNode("strong", null, "3. Haftung für Links")
        ]),
        _createElementVNode("p", { class: "" }, " Unsere Webseite enthält Links zu Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb übernehmen wir für diese fremden Inhalte keine Gewähr. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die Webseite enthält insbesondere einen Link zu unserem Kundenportal („Kunden-Login“), dessen Nutzung besonderen Bedingungen unterliegt. "),
        _createElementVNode("p", { class: "" }),
        _createElementVNode("p", { class: "" }, [
          _createElementVNode("strong", null, "4. Urheberrecht")
        ]),
        _createElementVNode("p", { class: "" }, " Die durch uns erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen unserer Zustimmung. Soweit die Inhalte auf dieser Seite nicht von uns erstellt wurden, werden die Urheberrechte Dritter beachtet. "),
        _createElementVNode("p", { class: "" }),
        _createElementVNode("p", { class: "" }, [
          _createElementVNode("strong", null, "5. Marke")
        ]),
        _createElementVNode("p", { class: "" }, " Unser Name und unser Logo sind markenrechtlich geschützt. Auch andere Firmenbezeichnungen, Firmenlogos und Produktnamen, die auf unserer Webseite genannt werden, können geschützte Marken der jeweiligen Inhaber sein. ")
      ], -1)
    ]))]),
    _: 1
  }))
}
}

})